import { UserPermissions } from '@centecomm/portal-service';
import { User as UserIcon } from 'Icons';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import { LaunchDarklyFlags } from 'utils/Hooks/LaunchDarkly/launchDarklyFlags';

import { FeatureConfiguration } from '../../../../Core/Types/FeatureConfiguration';

const LazyTenantPaymentsAdministrationPage = React.lazy(() => import('./Pages/Tenant/PaymentsAdministrationPage'));
const LazyPaymentsPreferencesPage = React.lazy(() => import('./Pages/OwnerOperator/PaymentsPreferencesPage'));

const paymentsConfiguration: FeatureConfiguration = {
    name: 'administrationFeature:company.payments.title',
    navigationItem: {
        route: {
            text: 'administrationFeature:sidebar.company.payments.title',
            url: '/payments-settings',
            Icon: UserIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyPaymentsPreferencesPage />
                </React.Suspense>
            ),
            tenantRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyTenantPaymentsAdministrationPage />
                </React.Suspense>
            ),
        },
        isGloballyAccessible: false,
        permissions: [UserPermissions.ManageAdminConfig, UserPermissions.ManagePaymentMethods],
    },
    disableFeature: [],
    launchDarklyFlags: [LaunchDarklyFlags.Payments],
};

export default paymentsConfiguration;
